import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/common/Header/Header';
import Footer from '../../components/common/Footer/Footer';
import ContactForm from '../../components/common/ContactForm';


const ourfarmpage = () => {
  const [showVideo, setShowVideo] = useState(false);
  const navigate = useNavigate();

  const handleVideoClick = () => {
    setShowVideo(true);
  };

  const handleGetQuoteClick = () => {
    navigate('/about/contact');
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const styles = {
    pageContainer: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      backgroundColor: '#ffffff',
    },
    
    // Header styles
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1rem 4rem',
      backgroundColor: 'white',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      borderBottom: '1px solid #f0f0f0',
    },
    logo: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#4a7c59',
    },
    logoIcon: {
      width: '40px',
      height: '40px',
      backgroundColor: '#4a7c59',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '1.2rem',
    },
    nav: {
      display: 'flex',
      gap: '2rem',
    },
    navLink: {
      color: '#666',
      textDecoration: 'none',
      fontWeight: '500',
      fontSize: '1rem',
      transition: 'color 0.3s ease',
    },
    navLinkActive: {
      color: '#4a7c59',
      fontWeight: '600',
    },

    // Hero section - exact match to image
    heroSection: {
      position: 'relative',
      height: '100vh',
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${require('../../assets/images/ourfarmheroimage.png')})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      alignItems: 'center',
      color: 'white',
    },
    videoOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    videoContainer: {
      position: 'relative',
      width: '90%',
      height: '70%',
      maxWidth: '1000px',
    },
    closeButton: {
      position: 'absolute',
      top: '-50px',
      right: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      border: '2px solid white',
      borderRadius: '50%',
      color: 'white',
      fontSize: '1.5rem',
      cursor: 'pointer',
      padding: '10px',
      width: '45px',
      height: '45px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s ease',
    },
    heroContent: {
      position: 'absolute',
      left: '4rem',
      top: '50%',
      transform: 'translateY(-50%)',
      maxWidth: '700px',
    },
    heroMainTitle: {
      fontSize: '5rem',
      fontWeight: '700',
      lineHeight: '0.9',
      marginBottom: '0.5rem',
      textTransform: 'uppercase',
      letterSpacing: '-0.02em',
    },
    heroSecondTitle: {
      fontSize: '5rem',
      fontWeight: '700',
      lineHeight: '0.9',
      marginBottom: '2rem',
      textTransform: 'uppercase',
      letterSpacing: '-0.02em',
    },
    heroTakeALook: {
      fontSize: '4rem',
      fontWeight: '300',
      lineHeight: '0.9',
      marginBottom: '2rem',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
    },
    heroDescription: {
      fontSize: '1.1rem',
      lineHeight: '1.6',
      opacity: 0.9,
      maxWidth: '500px',
    },
    playButton: {
      position: 'absolute',
      right: '6rem',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '120px',
      height: '120px',
      borderRadius: '50%',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      border: '3px solid white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      fontSize: '2rem',
      color: 'white',
      transition: 'all 0.3s ease',
    },
    actualShootBadge: {
      position: 'absolute',
      bottom: '2rem',
      right: '2rem',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      color: '#2d5016',
      padding: '1rem 2rem',
      borderRadius: '8px',
      fontWeight: '600',
      fontSize: '1rem',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    },

    // At SiriDharini section - exact match
    atSiriDhariniSection: {
      padding: '8rem 0',
      backgroundColor: '#ffffff',
    },
    sectionContainer: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 4rem',
    },
    sectionGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 600px',
      gap: '6rem',
      alignItems: 'center',
    },
    sectionContent: {
      display: 'flex',
      flexDirection: 'column',
    },
    sectionMainTitle: {
      fontSize: '4rem',
      fontWeight: '700',
      color: '#2d5016',
      textTransform: 'uppercase',
      lineHeight: '0.9',
      marginBottom: '0.5rem',
    },
    sectionSubTitle: {
      fontSize: '3rem',
      color: '#c49b6b',
      fontWeight: '300',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      lineHeight: '1.1',
      marginBottom: '3rem',
    },
    sectionDescription: {
      fontSize: '1.1rem',
      lineHeight: '1.8',
      color: '#666666',
    },
    sectionImage: {
      width: '100%',
      height: '450px',
      objectFit: 'cover',
      borderRadius: '12px',
    },

    // Promise section - exact match
    promiseSection: {
      padding: '8rem 0',
      backgroundColor: '#ffffff',
    },
    promiseMainTitle: {
      fontSize: '4rem',
      fontWeight: '700',
      color: '#2d5016',
      textAlign: 'center',
      marginBottom: '0.5rem',
      textTransform: 'uppercase',
      lineHeight: '0.9',
    },
    promiseSubTitle: {
      fontSize: '3rem',
      color: '#c49b6b',
      fontWeight: '300',
      textAlign: 'center',
      marginBottom: '6rem',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      lineHeight: '1.1',
    },
    promiseGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '4rem 3rem',
      marginBottom: '4rem',
    },
    promiseCard: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '1.5rem',
    },
    promiseIcon: {
      width: '80px',
      height: '80px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.5rem',
      flexShrink: 0,
    },
    promiseCardContent: {
      flex: 1,
    },
    promiseCardTitle: {
      fontSize: '1.3rem',
      fontWeight: '600',
      color: '#2d5016',
      marginBottom: '0.5rem',
    },
    promiseCardText: {
      fontSize: '1rem',
      lineHeight: '1.6',
      color: '#666666',
    },

    // Farm sizes section - exact match
    farmSizesSection: {
      padding: '8rem 0',
      backgroundColor: '#ffffff',
      textAlign: 'center',
    },
    farmSizesMainTitle: {
      fontSize: '4rem',
      fontWeight: '700',
      color: '#2d5016',
      marginBottom: '0.5rem',
      textTransform: 'uppercase',
      lineHeight: '0.9',
    },
    farmSizesSubTitle: {
      fontSize: '3rem',
      color: '#c49b6b',
      fontWeight: '300',
      marginBottom: '3rem',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      lineHeight: '1.1',
    },
    farmSizesDescription: {
      fontSize: '1.2rem',
      color: '#666666',
      marginBottom: '3rem',
    },
    getQuoteButton: {
      backgroundColor: 'transparent',
      border: '2px solid #2d5016',
      color: '#2d5016',
      padding: '1.2rem 3rem',
      fontSize: '1.1rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      borderRadius: '50px',
      cursor: 'pointer',
      marginBottom: '6rem',
      transition: 'all 0.3s ease',
    },
    moneyGrowsTitle: {
      fontSize: '3.5rem',
      fontWeight: '700',
      color: '#2d5016',
      textTransform: 'uppercase',
      lineHeight: '1.1',
    },
    moneyGrowsHighlight: {
      color: '#c49b6b',
    },

    // Weekend section - exact match
    weekendSection: {
      padding: '8rem 0',
      backgroundColor: '#ffffff',
    },
    weekendGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 600px',
      gap: '6rem',
      alignItems: 'flex-start',
    },
    weekendMainTitle: {
      fontSize: '4rem',
      fontWeight: '700',
      color: '#2d5016',
      textTransform: 'uppercase',
      lineHeight: '0.9',
      marginBottom: '0.5rem',
    },
    weekendSubTitle: {
      fontSize: '3rem',
      color: '#c49b6b',
      fontWeight: '300',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      lineHeight: '1.1',
      marginBottom: '3rem',
    },
    weekendImage: {
      width: '100%',
      height: '450px',
      objectFit: 'cover',
      borderRadius: '12px',
    },

    // Layout section - between weekend and crops
    layoutSection: {
      padding: '6rem 0',
      backgroundColor: '#ffffff',
      textAlign: 'center'
    },
    layoutTitle: {
      fontSize: '4rem',
      fontWeight: '700',
      color: '#2d5016',
      marginBottom: '0.5rem',
      textTransform: 'uppercase',
      lineHeight: '0.9',
    },
    layoutSubTitle: {
      fontSize: '3rem',
      color: '#c49b6b',
      fontWeight: '300',
      marginBottom: '4rem',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      lineHeight: '1.1',
    },
    layoutImage: {
      width: '100%',
      maxWidth: '1200px',
      height: 'auto',
      margin: '0 auto',
      borderRadius: '12px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    },

    // Crops section - Grid style like home page
    cropsSection: {
      padding: '6rem 0',
      backgroundColor: '#ffffff'
    },
    cropsMainTitle: {
      fontSize: '4rem',
      fontWeight: '700',
      color: '#2d5016',
      textAlign: 'center',
      marginBottom: '0.5rem',
      textTransform: 'uppercase',
      lineHeight: '0.9',
    },
    cropsSubTitle: {
      fontSize: '3rem',
      color: '#c49b6b',
      fontWeight: '300',
      textAlign: 'center',
      marginBottom: '6rem',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      lineHeight: '1.1',
    },
    newCropsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridTemplateRows: 'repeat(3, 1fr)',
      gap: '1rem',
      minHeight: '600px',
      width: '100%',
      margin: '0',
      padding: '0'
    },
    newTextCard: {
      gridArea: '1 / 1 / 2 / 2',
      backgroundColor: '#ffffff',
      padding: '2rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      borderRadius: '8px',
      border: '1px solid #e5e7eb'
    },
    newCropsTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#2c5f5f',
      margin: '0 0 1rem 0',
      textTransform: 'uppercase'
    },
    newCropsSubtitle: {
      color: '#E67E22',
      textTransform: 'uppercase',
      letterSpacing: '0.1rem',
      marginBottom: '1rem',
      fontSize: '3rem',
      fontWeight: '700'
    },
    newCropsText: {
      color: '#6b7280',
      fontSize: '1rem',
      lineHeight: '1.6',
      marginBottom: '2rem'
    },
    newCropsButton: {
      backgroundColor: '#2c5f5f',
      color: 'white',
      border: 'none',
      padding: '1rem 2rem',
      borderRadius: '25px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontSize: '1rem',
      letterSpacing: '0.1rem',
      textTransform: 'uppercase',
      width: 'fit-content'
    },
    newCropCard: {
      borderRadius: '8px',
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      cursor: 'pointer',
      transition: 'transform 0.3s ease'
    },
    newCropOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '1.5rem',
      fontWeight: '700',
      textAlign: 'center',
      textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
      textTransform: 'uppercase',
      letterSpacing: '0.1rem'
    },
    newSandalwood: {
      gridArea: '1 / 3 / 2 / 4',
      backgroundImage: 'url("' + require('../../assets/images/artificial-agarwood-incense-oud-sticks-and-chips-ULQ42HH.jpg') + '")',
    },
    newTeak: {
      gridArea: '1 / 2 / 2 / 3',
      backgroundImage: 'url("' + require('../../assets/images/repotting-fiddle-leaf-fig-tree-in-big-modern-pot-f-3KEUX23.jpg') + '")',
    },
    newMahogany: {
      gridArea: '2 / 1 / 3 / 2',
      backgroundImage: 'url("' + require('../../assets/images/mahogony.jpg') + '")',
    },
    newDrumsticks: {
      gridArea: '2 / 2 / 3 / 3',
      backgroundImage: 'url("' + require('../../assets/images/Moringa.jpeg') + '")',
    },
    newGuava: {
      gridArea: '2 / 3 / 3 / 4',
      backgroundImage: 'url("' + require('../../assets/images/special-offer-2.jpg') + '")',
    },
    newPomegranate: {
      gridArea: '3 / 1 / 4 / 3',
      backgroundImage: 'url("' + require('../../assets/images/pomegrenate-1.jpg') + '")',
    },
    newBigAmla: {
      gridArea: '3 / 3 / 4 / 4',
      backgroundImage: 'url("' + require('../../assets/images/amla-tree-A7V3JYF.jpg') + '")',
    },

    // Gallery section - exact match
    gallerySection: {
      padding: '8rem 0',
      backgroundColor: '#ffffff',
    },
    galleryMainTitle: {
      fontSize: '4rem',
      fontWeight: '700',
      color: '#2d5016',
      textAlign: 'center',
      marginBottom: '0.5rem',
      textTransform: 'uppercase',
      lineHeight: '0.9',
    },
    gallerySubTitle: {
      fontSize: '3rem',
      color: '#c49b6b',
      fontWeight: '300',
      textAlign: 'center',
      marginBottom: '6rem',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      lineHeight: '1.1',
    },
    galleryGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '2rem',
    },
    galleryImage: {
      width: '100%',
      height: '350px',
      objectFit: 'contain',
      borderRadius: '8px',
      transition: 'transform 0.3s ease',
      cursor: 'pointer',
      backgroundColor: '#f8f9fa',
    },

    // Contact Section
    contactSection: {
      background: 'linear-gradient(135deg, #E67E22 0%, #D35400 100%)',
      color: 'white',
      padding: '6rem 0',
      textAlign: 'center'
    },
    contactTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      margin: '0 0 3rem 0',
      textTransform: 'uppercase'
    },
    contactGrid: {
      maxWidth: '800px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '2rem'
    },
    inputGroup: {
      display: 'flex',
      flexDirection: 'column'
    },
    inputLabel: {
      fontSize: '1rem',
      marginBottom: '0.5rem',
      textAlign: 'left',
      opacity: '0.9'
    },
    input: {
      padding: '1rem 0',
      border: 'none',
      borderBottom: '2px solid rgba(255,255,255,0.3)',
      backgroundColor: 'transparent',
      color: 'white',
      fontSize: '1rem',
      outline: 'none'
    },
    textareaGroup: {
      gridColumn: 'span 2',
      display: 'flex',
      flexDirection: 'column'
    },
    textarea: {
      padding: '1rem 0',
      border: 'none',
      borderBottom: '2px solid rgba(255,255,255,0.3)',
      backgroundColor: 'transparent',
      color: 'white',
      fontSize: '1rem',
      outline: 'none',
      minHeight: '100px',
      resize: 'vertical'
    },
    sendButton: {
      gridColumn: 'span 2',
      marginTop: '2rem',
      padding: '1rem 3rem',
      backgroundColor: 'transparent',
      border: '2px solid white',
      color: 'white',
      borderRadius: '25px',
      fontSize: '1.1rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },

    // Map Section
    mapSection: {
      padding: '60px 0',
      backgroundColor: 'white'
    },
    mapTitle: {
      fontSize: '2rem',
      textAlign: 'center',
      marginBottom: '2rem',
      color: '#2d5016'
    },
    mapContainer: {
      width: '100vw',
      position: 'relative',
      left: '50%',
      right: '50%',
      marginLeft: '-50vw',
      marginRight: '-50vw',
      overflow: 'hidden'
    },

    // Responsive styles
    '@media (max-width: 1024px)': {
      sectionGrid: {
        gridTemplateColumns: '1fr',
        textAlign: 'center',
      },
      weekendGrid: {
        gridTemplateColumns: '1fr',
      },
      promiseGrid: {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
      newCropsGrid: {
        gridTemplateColumns: 'repeat(2, 1fr) !important',
        gridTemplateRows: 'repeat(4, 120px) !important',
      },
    },
    '@media (max-width: 768px)': {
      heroMainTitle: {
        fontSize: '3rem',
      },
      heroSecondTitle: {
        fontSize: '3rem',
      },
      heroTakeALook: {
        fontSize: '2.5rem',
      },
      sectionMainTitle: {
        fontSize: '2.5rem',
      },
      sectionSubTitle: {
        fontSize: '2rem',
      },
      promiseGrid: {
        gridTemplateColumns: '1fr',
      },
      newCropsGrid: {
        gridTemplateColumns: '1fr !important',
        gridTemplateRows: 'repeat(8, 120px) !important',
      },
      galleryGrid: {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
    },
  };

  return (
    <>
      <style>{`
        .new-crop-card:hover {
          transform: scale(1.02);
        }
        
        .new-crops-btn:hover {
          background-color: #1a4f4f;
        }
        
        .send-btn:hover {
          background-color: white;
          color: #E67E22;
        }
        
        .input::placeholder,
        .textarea::placeholder {
          color: rgba(255,255,255,0.7);
        }
        
        .input:focus,
        .textarea:focus {
          border-bottom-color: white;
        }
        
        .gallery-image:hover {
          transform: scale(1.05);
        }
        
        .play-button {
          animation: pulseGlow 2s infinite;
        }
        
        @keyframes pulseGlow {
          0%, 100% {
            transform: translateY(-50%) scale(1);
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
            border: 3px solid white;
          }
          50% {
            transform: translateY(-50%) scale(1.05);
            box-shadow: 0 0 0 8px rgba(255, 255, 255, 0);
            border: 3px solid rgba(255, 255, 255, 0.9);
          }
        }
        
        .play-button:hover {
          animation-play-state: paused;
          transform: translateY(-50%) scale(1.1);
          background-color: rgba(0, 0, 0, 0.8);
          border: 3px solid white;
        }
        
        @media (max-width: 1024px) {
          .responsive-new-crops-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            grid-template-rows: repeat(4, 120px) !important;
          }
          .responsive-contact-grid {
            grid-template-columns: 1fr !important;
          }
        }
        
        @media (max-width: 768px) {
          .responsive-new-crops-grid {
            grid-template-columns: 1fr !important;
            grid-template-rows: repeat(8, 120px) !important;
          }
        }
      `}</style>
      
      <div style={styles.pageContainer}>
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section style={styles.heroSection}>
        <div style={styles.heroContent}>
          <h1 style={styles.heroMainTitle}>YOUR FARMLAND</h1>
          <h2 style={styles.heroSecondTitle}>AWAITS</h2>
          <h3 style={styles.heroTakeALook}>TAKE A LOOK</h3>
          <p style={styles.heroDescription}>
            With 10 acres of luscious farmlands located a stone's throw away from Bengaluru, 
            this is where Siri (wealth) meets Dharini (Earth).
          </p>
        </div>
        <div style={styles.playButton} className="play-button" onClick={handleVideoClick}>
          ▶
        </div>
      </section>

      {/* Video Overlay */}
      {showVideo && (
        <div style={styles.videoOverlay}>
          <div style={styles.videoContainer}>
            <button 
              style={styles.closeButton}
              onClick={() => setShowVideo(false)}
            >
              ✕
            </button>
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/82voB1b5sZU?autoplay=1&rel=0&modestbranding=1"
              title="Introducing SiriDharini | #ManagedFarmland - Bengaluru"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{border: '0', borderRadius: '8px'}}
            ></iframe>
          </div>
        </div>
      )}

      {/* At SiriDharini Section */}
      <section style={styles.atSiriDhariniSection}>
        <div style={styles.sectionContainer}>
          <div style={styles.sectionGrid}>
            <div style={styles.sectionContent}>
              <h2 style={styles.sectionMainTitle}>AT SIRIDHARINI</h2>
              <h3 style={styles.sectionSubTitle}>WE'RE YOUR<br />FARMERS IN ARMS</h3>
              <p style={styles.sectionDescription}>
                Located just 50 kilometers from the heart of Bengaluru, SiriDharini encompasses 10 acres of fertile 
                farmlands in a hamlet known as Thally. With good soil quality and ample water, this is a haven for the nature 
                enthusiast in you. Away from the pollution of the metropolis, SiriDharini promises fresh air, rows upon 
                rows of timber trees, fresh fruits and vegetables, high-profit sandalwood, and an opportunity to give back to 
                Mother Earth.
              </p>
            </div>
            <img 
              src={require('../../assets/images/Moringa.jpeg')}
              alt="Green farmland"
              style={styles.sectionImage}
            />
          </div>
        </div>
      </section>

      {/* Promise Section */}
      <section style={styles.promiseSection}>
        <div style={styles.sectionContainer}>
          <h2 style={styles.promiseMainTitle}>THE PROMISE</h2>
          <h3 style={styles.promiseSubTitle}>OF SIRIDHARINI</h3>
          <div style={styles.promiseGrid}>
            <div style={styles.promiseCard}>
              <div style={styles.promiseIcon}>
                <img src={require('../../assets/images/Easy-connectivity-19.png')} alt="Easy Connectivity" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <div style={styles.promiseCardContent}>
                <h4 style={styles.promiseCardTitle}>Easy Connectivity</h4>
                <p style={styles.promiseCardText}>50 kms from Bengaluru & 35 kms from Electronic City</p>
              </div>
            </div>
            <div style={styles.promiseCard}>
              <div style={styles.promiseIcon}>
                <img src={require('../../assets/images/environment-Impact-21.png')} alt="Environmental Impact" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <div style={styles.promiseCardContent}>
                <h4 style={styles.promiseCardTitle}>Environmental Impact</h4>
                <p style={styles.promiseCardText}>Practices to improve soil quality, replenish groundwater, etc.</p>
              </div>
            </div>
            <div style={styles.promiseCard}>
              <div style={styles.promiseIcon}>
                <img src={require('../../assets/images/natureactivity.png')} alt="Nature Activities" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <div style={styles.promiseCardContent}>
                <h4 style={styles.promiseCardTitle}>Nature Activities</h4>
                <p style={styles.promiseCardText}>Hiking & cycling trails, waterfalls, viewing points</p>
              </div>
            </div>
            <div style={styles.promiseCard}>
              <div style={styles.promiseIcon}>
                <img src={require('../../assets/images/ecoliving.png')} alt="Eco-Living" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <div style={styles.promiseCardContent}>
                <h4 style={styles.promiseCardTitle}>Eco-Living</h4>
                <p style={styles.promiseCardText}>Farm to table cuisine, organic fruits & veggies to take home</p>
              </div>
            </div>
            <div style={styles.promiseCard}>
              <div style={styles.promiseIcon}>
                <img src={require('../../assets/images/social-impact-22.png')} alt="Social Impact" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <div style={styles.promiseCardContent}>
                <h4 style={styles.promiseCardTitle}>Social Impact</h4>
                <p style={styles.promiseCardText}>Job creation & community welfare</p>
              </div>
            </div>
            <div style={styles.promiseCard}>
              <div style={styles.promiseIcon}>
                <img src={require('../../assets/images/luxury farmhouse clubhouse and threehouse.png')} alt="Idyllic Getaway" style={{width: '60px', height: '60px', objectFit: 'contain'}} />
              </div>
              <div style={styles.promiseCardContent}>
                <h4 style={styles.promiseCardTitle}>Idyllic Getaway</h4>
                <p style={styles.promiseCardText}>Enjoy weekends, vacations & retirement</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Farm Sizes Section */}
      <section style={styles.farmSizesSection}>
        <div style={styles.sectionContainer}>
          <h2 style={styles.farmSizesMainTitle}>FARM</h2>
          <h3 style={styles.farmSizesSubTitle}>SIZES</h3>
          <p style={styles.farmSizesDescription}>Quarter acre plot of land.</p>
          <button style={styles.getQuoteButton} onClick={handleGetQuoteClick}>Get Quote</button>
          <h2 style={styles.moneyGrowsTitle}>
            MONEY DOES <span style={styles.moneyGrowsHighlight}>GROW ON TREES</span>
          </h2>
        </div>
      </section>

      {/* Weekend Section */}
      <section style={styles.weekendSection}>
        <div style={styles.sectionContainer}>
          <div style={styles.weekendGrid}>
            <div style={styles.sectionContent}>
              <h2 style={styles.weekendMainTitle}>A GLIMPSE INTO</h2>
              <h3 style={styles.weekendSubTitle}>A<br />WEEKEND AT SIRIDHARINI</h3>
              <p style={styles.sectionDescription}>
                Your weekend at SiriDharini begins with a scenic drive to the farm. Once you reach, 
                you'll be set up in your private cottage. Luxuriously appointed with comfortable 
                couches and reading nooks, our cottages are designed to help you relax and descend 
                into serenity. Occupy your days with hikes and bicycle rides along verdant trails that 
                lead you to quaint temples and waterfalls. Not in the mood for activity? Laze in the 
                sun dappled shade of flowering trees while enjoying fresh fruit straight from the 
                source. To top off your perfect weekend, enjoy delicious farm to table cuisine, a 
                clubhouse, panoramic views from treehouses, and lots more.
              </p>
            </div>
            <img 
              src="https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Fresh vegetables"
              style={styles.weekendImage}
            />
          </div>
        </div>
      </section>

      {/* Layout Section */}
      <section style={styles.layoutSection}>
        <div style={styles.sectionContainer}>
          <h2 style={styles.layoutTitle}>FARM</h2>
          <h3 style={styles.layoutSubTitle}>LAYOUT</h3>
          <img 
            src={require('../../assets/images/layout-1024x729.png')} 
            alt="SiriDharini Farm Layout Plan" 
            style={styles.layoutImage}
          />
        </div>
      </section>

      {/* Crops Section */}
      <section style={styles.cropsSection}>
        {/* New crops grid matching home page */}
        <div style={styles.newCropsGrid} className="responsive-new-crops-grid">
            {/* Text Content as first card */}
            <div style={styles.newTextCard}>
              <h2 style={styles.newCropsTitle}>
                DELVE <span style={styles.newCropsSubtitle}>DEEPER</span>
              </h2>
              <p style={styles.newCropsText}>
                Into the world of SiriDharini and discover the diverse range of crops that make our farmlands a haven for sustainable agriculture and profitable returns.
              </p>
              <button style={styles.newCropsButton} className="new-crops-btn">
                EXPLORE
              </button>
            </div>
            {/* Crop cards */}
            <div style={{...styles.newCropCard, ...styles.newSandalwood}} className="new-crop-card">
              <div style={styles.newCropOverlay}>SANDALWOOD</div>
            </div>
            <div style={{...styles.newCropCard, ...styles.newTeak}} className="new-crop-card">
              <div style={styles.newCropOverlay}>TEAK</div>
            </div>
            <div style={{...styles.newCropCard, ...styles.newMahogany}} className="new-crop-card">
              <div style={styles.newCropOverlay}>MAHOGANY</div>
            </div>
            <div style={{...styles.newCropCard, ...styles.newDrumsticks}} className="new-crop-card">
              <div style={styles.newCropOverlay}>DRUMSTICKS</div>
            </div>
            <div style={{...styles.newCropCard, ...styles.newGuava}} className="new-crop-card">
              <div style={styles.newCropOverlay}>GUAVA (LUCKNOW 49)</div>
            </div>
            <div style={{...styles.newCropCard, ...styles.newPomegranate}} className="new-crop-card">
              <div style={styles.newCropOverlay}>POMEGRANATE</div>
            </div>
            <div style={{...styles.newCropCard, ...styles.newBigAmla}} className="new-crop-card">
              <div style={styles.newCropOverlay}>BIG AMLA</div>
            </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section style={styles.gallerySection}>
        <div style={styles.sectionContainer}>
          <h2 style={styles.galleryMainTitle}>SIRIDHARINI AT</h2>
          <h3 style={styles.gallerySubTitle}>A GLIMPSE!</h3>
          <div style={styles.galleryGrid}>
            <img src={require('../../assets/images/siridhariniglimps1.png')} alt="Family planting together at SiriDharini" style={styles.galleryImage} className="gallery-image" />
            <img src={require('../../assets/images/siridhariniglimps2.jpeg')} alt="Children enjoying farm activities" style={styles.galleryImage} className="gallery-image" />
            <img src={require('../../assets/images/siridhariniglimps3.jpeg')} alt="Happy families at SiriDharini farm" style={styles.galleryImage} className="gallery-image" />
            <img src={require('../../assets/images/siridhariniglimps4.jpeg')} alt="Farm visitors enjoying nature" style={styles.galleryImage} className="gallery-image" />
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <ContactForm 
        pageSource="Farm Page"
        title="Get In Touch"
        onSubmitSuccess={(result) => {
          console.log('Farm page contact form submitted successfully:', result);
        }}
        onSubmitError={(error) => {
          console.error('Farm page contact form submission failed:', error);
        }}
      />

      {/* Map Section */}
      <section style={styles.mapSection}>
        <div style={styles.sectionContainer}>
          <h2 style={styles.mapTitle}>Our Farm Location</h2>
        </div>
        {/* Full-width map container */}
        <div style={styles.mapContainer}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2835.0184872672107!2d77.65422287387703!3d12.620336053815237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae65e9bcb4a251%3A0x76b1620925218475!2sSiridharini!5e1!3m2!1sen!2sin!4v1784033535484!5m2!1sen!2sin"
            width="100%"
            height="500"
            style={{border: 0}}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            title="Siridharini Farmlands - Exact Location"
          ></iframe>
        </div>
        <div style={styles.sectionContainer}>
          <div style={{textAlign: 'center', marginTop: '1rem', color: '#666'}}>
            📍 Siridharini Farmlands<br />
            615/1, Gopasandra, Deverabetta Road<br />
            Next to Reed Relays & Electronics, Thali Post Denkanekote
            <br /><br />
            <a 
              href="https://maps.app.goo.gl/HUfwR9MsKd2Yox3M8"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                background: '#4A7C59',
                color: 'white',
                padding: '12px 24px',
                borderRadius: '6px',
                textDecoration: 'none',
                fontWeight: 'bold',
                marginTop: '10px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                transition: 'background 0.3s ease'
              }}
              onMouseOver={(e) => e.target.style.background = '#3a5e47'}
              onMouseOut={(e) => e.target.style.background = '#4A7C59'}
            >
              📍 View Exact Location on Google Maps
            </a>
          </div>
        </div>
      </section>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default ourfarmpage;